import { jsx } from "panel";
import { TooltipEl } from "common/components/tooltip";
import { DisplayType, Placement } from "common/components/tooltip/types";
import { SvgIconEl } from "common/components/svg-icon";
import { TagSelectorEl } from "common/widgets/tag-selector";
import { DropMenuEl } from "common/components/drop-menu";
import { ButtonEl } from "common/components/button";
import { ButtonTheme, ButtonType } from "common/components/button/constants";
import { ItemsMenuEl } from "common/components/items-menu";
import { TagEl } from "common/components/tag";
import { SwitchEl } from "common/components/switch";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerColor } from "common/components/spinner/types";
import { formatText } from "common/util/format-text";
import { capitalize } from "common/util/string";
import { TagTheme } from "common/components/tag/types";
import { DecimalOptionEl } from "common/query-builder/chart-customization/metric-units/panel";
import { InputType } from "./types";
function SettingsLiInput(_ref) {
  var _settingsLiComponent$;
  let {
    settingsLiComponent
  } = _ref;
  const {
    editing,
    inputValue,
    password1,
    password2,
    saving,
    selectItems,
    selectMenuOpen,
    selectTagOpen,
    selectedTags,
    selectedValue,
    validationError
  } = settingsLiComponent.state;
  const disabled = settingsLiComponent.attr("disabled");
  const readonly = disabled || !editing || saving;
  const stagedPrecision = settingsLiComponent.state.stagedDecimalPrecision;
  switch (settingsLiComponent.helpers.inputType()) {
    case InputType.DecimalPrecision: {
      return /* @__PURE__ */ jsx("div", { sel: ".row" }, /* @__PURE__ */ jsx("div", { style: {
        gridColumn: "1"
      } }, /* @__PURE__ */ jsx(DecimalOptionEl, { precision: stagedPrecision !== void 0 ? stagedPrecision : settingsLiComponent.params.decimalPrecisionValue, setPrecision: (val) => settingsLiComponent.helpers.onDecimalPrecisionChange(val), isLeft: true, disabled: !settingsLiComponent.attr("editable") || !editing })), /* @__PURE__ */ jsx("div", { style: {
        gridColumn: "2"
      } }, /* @__PURE__ */ jsx(DecimalOptionEl, { precision: stagedPrecision !== void 0 ? stagedPrecision : settingsLiComponent.params.decimalPrecisionValue, setPrecision: (val) => settingsLiComponent.helpers.onDecimalPrecisionChange(val), isLeft: false, disabled: !settingsLiComponent.attr("editable") || !editing })));
    }
    case InputType.AbbrevToggle:
      return /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-text" }, /* @__PURE__ */ jsx(SwitchEl, { attrs: {
        on: (_settingsLiComponent$ = settingsLiComponent.state.stagedAbbrev) !== null && _settingsLiComponent$ !== void 0 ? _settingsLiComponent$ : settingsLiComponent.attr("switchon"),
        disabled: !editing
      }, on: {
        change: settingsLiComponent.helpers.onAbbrevChange
      } }));
    case InputType.Switch:
    case InputType.Text: {
      if (readonly) {
        let tooltipEl;
        if (settingsLiComponent.attr("tooltip")) {
          tooltipEl = /* @__PURE__ */ jsx(TooltipEl, null, settingsLiComponent.attr("tooltip"));
        }
        return /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-text" }, settingsLiComponent.attr("format-text") ? formatText(inputValue, !settingsLiComponent.attr("maxlength") ? {} : {
          maxLength: settingsLiComponent.attr("maxlength")
        }) : inputValue, tooltipEl);
      }
      return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("input", { sel: ".remove-chrome-form-style", attrs: {
        maxlength: settingsLiComponent.attr("maxlength"),
        placeholder: settingsLiComponent.attr("placeholder"),
        type: "text"
      }, props: {
        value: inputValue
      }, on: {
        input: settingsLiComponent.helpers.inputUpdated,
        keydown: settingsLiComponent.helpers.handleKeydown
      }, hook: {
        insert: settingsLiComponent.helpers.inputInserted
      } }), validationError ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
        "always-show": true,
        type: DisplayType.Error
      } }, validationError) : null);
    }
    case InputType.TextArea: {
      const DEFAULT_ROWS = 6;
      if (readonly) {
        let tooltipEl;
        if (settingsLiComponent.attr("tooltip")) {
          tooltipEl = /* @__PURE__ */ jsx(TooltipEl, null, settingsLiComponent.attr("tooltip"));
        }
        return /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-text" }, settingsLiComponent.attr("format-text") ? formatText(inputValue, !settingsLiComponent.attr("maxlength") ? {} : {
          maxLength: settingsLiComponent.attr("maxlength")
        }) : inputValue, tooltipEl);
      }
      return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("textarea", { sel: ".remove-chrome-form-style", attrs: {
        maxlength: settingsLiComponent.attr("maxlength"),
        placeholder: settingsLiComponent.attr("placeholder"),
        rows: !settingsLiComponent.attr("text-area-rows") ? DEFAULT_ROWS : settingsLiComponent.attr("text-area-rows")
      }, props: {
        value: inputValue
      }, on: {
        input: settingsLiComponent.helpers.inputUpdated,
        keydown: settingsLiComponent.helpers.handleKeydown
      }, hook: {
        insert: settingsLiComponent.helpers.inputInserted
      }, style: {
        resize: !settingsLiComponent.attr("text-area-resize") ? "none" : settingsLiComponent.attr("text-area-resize")
      } }));
    }
    case InputType.Password: {
      return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("input", { sel: ".remove-chrome-form-style", attrs: {
        disabled: readonly,
        maxlength: settingsLiComponent.attr("maxlength"),
        placeholder: "New password",
        type: "password"
      }, props: {
        value: editing ? password1 : inputValue
      }, on: {
        input: (ev) => settingsLiComponent.helpers.passwordUpdated(1, ev)
      }, hook: {
        insert: settingsLiComponent.helpers.inputInserted
      } }), editing ? /* @__PURE__ */ jsx("input", { sel: ".remove-chrome-form-style", attrs: {
        disabled: disabled || saving,
        placeholder: "Confirm password",
        type: "password"
      }, props: {
        value: password2
      }, on: {
        input: (ev) => settingsLiComponent.helpers.passwordUpdated(2, ev)
      } }) : null);
    }
    case InputType.Tag: {
      if (editing || saving) {
        return /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-menu" }, /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-menu-container" }, /* @__PURE__ */ jsx(DropMenuEl, { attrs: {
          open: selectTagOpen
        }, on: {
          change: settingsLiComponent.helpers.handleTagMenuChange
        } }, /* @__PURE__ */ jsx(TagSelectorEl, { attrs: {
          options: settingsLiComponent.helpers.getTagOptions(),
          saving,
          "input-text": JSON.stringify({
            search: "Search tags...",
            empty: "No tags found",
            create: "Create new tag:"
          }),
          "min-tags": 0,
          "static-tags": settingsLiComponent.attr("static-tags"),
          multiline: settingsLiComponent.attr("multiline-input")
        }, on: {
          save: settingsLiComponent.helpers.clickedSave,
          change: settingsLiComponent.helpers.tagSelectorChanged
        }, hook: {
          insert: settingsLiComponent.helpers.inputInserted
        } }))));
      }
      const tags = Array.from(selectedTags);
      return tags.length ? /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-menu-tags-container" }, tags.map((tagName) => /* @__PURE__ */ jsx(TagEl, { attrs: {
        size: settingsLiComponent.attr("tag-size"),
        "tag-name": tagName,
        theme: TagTheme.Light,
        clickable: false,
        removable: false
      } }))) : null;
    }
    case InputType.Select: {
      if (editing || saving) {
        return /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-menu" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".settings-li-select-button", on: {
          click: settingsLiComponent.helpers.toggleSelectMenu
        } }, selectedValue.label), /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-menu-container" }, /* @__PURE__ */ jsx(DropMenuEl, { attrs: {
          open: selectMenuOpen
        }, on: {
          change: settingsLiComponent.helpers.handleSelectMenuChange
        } }, /* @__PURE__ */ jsx(ItemsMenuEl, { sel: ".mp-settings-li-menu-list", attrs: {
          sections: [{
            items: selectItems
          }]
        }, on: {
          clickItem: settingsLiComponent.helpers.selectItem
        } }))));
      }
      return /* @__PURE__ */ jsx("input", { sel: ".remove-chrome-form-style", attrs: {
        disabled: true,
        type: "text"
      }, props: {
        value: selectedValue.label
      }, hook: {
        insert: settingsLiComponent.helpers.inputInserted
      } });
    }
    case InputType.MultiSelect: {
      if (editing || saving) {
        return /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-menu" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".settings-li-select-button", on: {
          click: settingsLiComponent.helpers.toggleSelectMenu
        } }, inputValue), /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-menu-container" }, /* @__PURE__ */ jsx(DropMenuEl, { attrs: {
          open: selectMenuOpen
        }, on: {
          change: settingsLiComponent.helpers.handleSelectMenuChange
        } }, /* @__PURE__ */ jsx(ItemsMenuEl, { sel: ".mp-settings-li-menu-list", attrs: {
          sections: [{
            items: selectItems
          }],
          multiple: true
        }, on: {
          clickItem: settingsLiComponent.helpers.multiSelectItem
        } }))));
      }
      return /* @__PURE__ */ jsx("input", { sel: ".remove-chrome-form-style", attrs: {
        disabled: true,
        type: "text"
      }, props: {
        value: inputValue
      }, hook: {
        insert: settingsLiComponent.helpers.inputInserted
      } });
    }
    case InputType.PhoneNumber: {
      return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("input", { sel: ".remove-chrome-form-style", attrs: {
        disabled: readonly,
        placeholder: editing ? "+1" : "+1 (415) 123-1322",
        type: "text",
        name: editing ? "country-code" : "formatted-phone"
      }, props: {
        value: editing ? settingsLiComponent.helpers.parsePhoneNumber(inputValue).countryCode : inputValue
      }, on: {
        input: (ev) => settingsLiComponent.helpers.phoneNumberUpdated(ev)
      }, hook: {
        insert: settingsLiComponent.helpers.inputInserted
      } }), editing ? /* @__PURE__ */ jsx("input", { sel: ".remove-chrome-form-style", attrs: {
        disabled: disabled || saving,
        placeholder: "(415) 123-1322",
        type: "text",
        name: "local-phone-number"
      }, props: {
        value: settingsLiComponent.helpers.parsePhoneNumber(inputValue).localPhoneNumber
      }, on: {
        input: (ev) => settingsLiComponent.helpers.phoneNumberUpdated(ev)
      } }) : null, validationError ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
        "always-show": true,
        type: DisplayType.Error
      } }, validationError) : null);
    }
    case InputType.File: {
      return /* @__PURE__ */ jsx("input", { sel: ".remove-chrome-form-style", attrs: {
        disabled: true,
        type: "text"
      }, props: {
        value: inputValue
      } });
    }
    case InputType.Slot: {
      return /* @__PURE__ */ jsx("slot", null);
    }
    default:
      return /* @__PURE__ */ jsx("div", null);
  }
}
export function template() {
  const {
    editing,
    isFile,
    type,
    removable,
    saveDisabled,
    saving,
    uploading
  } = this.state;
  const disabled = this.attr("disabled");
  const hasTooltip = this.attr("disabled") && !this.attr("editable") && !!this.attr("disabled-message");
  const {
    t
  } = this.getContext("i18n");
  return /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li", class: {
    "mp-settings-li-disabled": disabled,
    "mp-settings-li-editing": editing,
    "mp-settings-li-select": this.isSelect,
    "mp-settings-li-uploading": uploading
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-label" }, /* @__PURE__ */ jsx("p", null, this.helpers.label()), this.attr("info") ? /* @__PURE__ */ jsx("div", { sel: ".icon-btn" }, /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Top,
    type: DisplayType.Default,
    "always-show": false,
    text: this.attr("info"),
    "max-width": "260px"
  } }), /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-label-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  } }))) : null, this.infoRenderer && /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-label-info-renderer" }, this.infoRenderer())), /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-value-cont", class: {
    "has-tooltip": hasTooltip
  } }, /* @__PURE__ */ jsx(SettingsLiInput, { settingsLiComponent: this, "data-sentry-element": "SettingsLiInput", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: ".mp-settings-li-button" }, (() => {
    const buttonIcon = this.attr("button-icon");
    const buttonText = this.attr("button");
    let buttonTheme = ButtonTheme.Secondary;
    const buttonThemeAttr = this.attr("button-theme");
    if (buttonThemeAttr) {
      buttonTheme = ButtonTheme[capitalize(buttonThemeAttr)];
    }
    const isDeleteButton = this.attr("delete-button");
    if (type === InputType.Switch) {
      return /* @__PURE__ */ jsx(SwitchEl, { attrs: {
        on: this.attr("switchon"),
        disabled
      }, on: {
        change: this.helpers.switchChanged
      } });
    } else if (isFile) {
      if (uploading) {
        return /* @__PURE__ */ jsx(null, null, removable ? /* @__PURE__ */ jsx(ButtonEl, { attrs: {
          theme: ButtonTheme.Tertiary,
          icon: "trashcan",
          type: ButtonType.Destructive
        }, on: {
          click: this.helpers.clickedRemove
        } }) : null, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
          disabled: saving
        }, on: {
          click: this.helpers.stopUploading
        } }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, { sel: ".mp-settings-li-file-save-button", attrs: {
          theme: ButtonTheme.Primary,
          disabled: saving
        }, on: {
          click: this.helpers.clickedUpload
        } }, this.attr("buttontext")), /* @__PURE__ */ jsx("input", { sel: ".mp-settings-li-hidden", attrs: {
          type: "file",
          accept: this.attr("fileaccept")
        }, on: {
          change: this.helpers.fileDialogEnded
        }, hook: {
          insert: this.helpers.fileInserted
        } }));
      }
      return /* @__PURE__ */ jsx(ButtonEl, { attrs: {
        theme: ButtonTheme.Tertiary,
        icon: "edit"
      }, on: {
        click: this.helpers.uploadFile
      } });
    } else if (editing && !this.attr("hide-buttons")) {
      const saveHandler = this.attr("custom-handling") ? this.helpers.customSave : this.helpers.clickedSave;
      const cancelHandler = this.attr("custom-handling") ? this.helpers.customCancel : this.helpers.stopEditing;
      return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
        disabled: saving
      }, on: {
        click: cancelHandler
      } }, t("common.cancel")), /* @__PURE__ */ jsx(ButtonEl, { sel: ".mp-settings-li-save-button", attrs: {
        theme: ButtonTheme.Primary,
        disabled: saving || !this.helpers.isSaveableInput() || saveDisabled
      }, on: {
        click: saveHandler
      } }, saving ? /* @__PURE__ */ jsx(SpinnerEl, { attrs: {
        color: SpinnerColor.White
      } }) : t("common.save")));
    } else if (!editing && this.attr("editable")) {
      return /* @__PURE__ */ jsx(ButtonEl, { attrs: {
        theme: ButtonTheme.Tertiary,
        icon: "edit"
      }, on: {
        click: this.helpers.startEditing
      } });
    } else if (buttonText) {
      return /* @__PURE__ */ jsx(ButtonEl, { attrs: {
        disabled,
        theme: buttonTheme,
        type: isDeleteButton ? ButtonType.Destructive : ButtonType.Info,
        icon: isDeleteButton ? "trashcan" : buttonIcon
      }, on: {
        click: this.helpers.clickedButton
      } }, buttonText);
    }
    return null;
  })()), hasTooltip ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Left
  } }, this.attr("disabled-message")) : null));
}
